<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Trees, woodland &amp; Vegetation</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Areas of saplings/young trees</li>
						<li>Bushes/shrubs</li>
						<li>Individual tree positions (minimum trunk diameter of 0.1m at 1.5m above ground level</li>
						<li>Isolated trees</li>
						<li>Ornamental/road side trees, including planting boxes</li>
					</div>
					<div class="col md-6">
						<li>Tree heights (measured – where visible)</li>
						<li>Tree spread (mean)</li>
						<li>Vegetation (light/dense)</li>
						<li>Woodlands (perimeter trees/canopy only)</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'VegetationModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/VegetationModal.vue